export const listUsersAdmin = state => state.usersAdminState;
export const getUserAdmin = state => state.usersAdminState;
